// All environment → base path mapping
export const basePaths = {
  qa: '/oak/qa',
  // Staging mirrors a production node: its own host, SPA at the docroot, API at
  // /backend. The old '/oak/staging' subfolder is from the shared-FTP era, when
  // qa/staging/demo/release3 all shared one host. It also broke deploy/deploy.sh
  // --env=staging, which rsyncs dist/ into the docroot — a bundle built for
  // '/oak/staging' 404s its own assets there.
  staging: '/',
  demo: '/oak/demo',
  // Per-node production builds are served from the docroot (the API lives
  // under /backend on the same origin — see backend dev/docs/deployment.md).
  production: '/',
  release3: '/oak/release3',
  test: '/oak/test',
  lawfirm: '/oak/lawfirm',
  default: '/',
  'live-client-instance': '/'
};

function isDevRuntime() {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return Boolean(import.meta.env.DEV);
  }

  return process.env.NODE_ENV !== 'production';
}

// Get current env (works in Vite and plain Node)
export function getAppEnv() {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env.VITE_APP_ENV || 'default';
  }
  return process.env.VITE_APP_ENV || 'default';
}

// Get current base path
export function getBasePath(options = {}) {
  const { includeDev = false } = options;

  if (!includeDev && isDevRuntime()) {
    return '/';
  }

  const env = getAppEnv();
  return basePaths[env] || basePaths.default;
}
